<p class="mat-typography">
    <mat-toolbar color="primary">
        <span>{{ appTitle }}{{ environmentSuffix }}</span>
        <span class="flex-auto"></span>
        <mat-nav-list class="list-horizontal">
            <ng-container *ngFor="let route of routes; let i = index">
                <!-- Menu items with children -->
                <mat-list-item *ngIf="route.children && route.children.length > 0">
                    <a [matMenuTriggerFor]="menu">{{ route.name }}</a>
                    <mat-menu #menu="matMenu">
                        <button 
                            mat-menu-item 
                            *ngFor="let child of route.children" 
                            [routerLink]="['/secure' + child.path]">
                            {{ child.name }}
                        </button>
                    </mat-menu>
                </mat-list-item>

                <!-- Simple menu items without children -->
                <mat-list-item *ngIf="!route.children || route.children.length === 0">
                    <a [routerLink]="['/secure' + route.path]">{{ route.name }}</a>
                </mat-list-item>
            </ng-container>
        </mat-nav-list>
        <span class="flex-auto"></span>
        <button mat-icon-button (click)="logout()">
            <mat-icon>logout</mat-icon>
        </button>
    </mat-toolbar>
</p>